import play from "./play.ts";

export default {
	play,
};
